export const initAliyunPlayer = (source) => {
    return new Aliplayer ({
            id: "player-con",
            vid : source.videoMeta.videoId,
            playauth : source.playAuth,
            cover: source.videoMeta.coverURL,
            encryptType:1, //当播放私有加密流时需要设置。
            width: "1098px",
            height: "618px",
            autoplay: false,
            language:"zh-cn",
            playsinline: true,
            isLive: false,
            // 是否循环播放
            rePlay: false,
            preload: true,
            controlBarVisibility: "always",
            disableSeek: true,
            "extraInfo": {
              "crossOrigin": "anonymous"
            },
            components: [
              // 记忆播放
              {
                name: 'MemoryPlayComponent',
                type: AliPlayerComponent.MemoryPlayComponent,
                /* Set the first parameter to true to enable auto play. The default is false. */
                args: [
                  false,
                  function (memoryVideo) {
                    // 获得最后播放时间
                    var lastPlayedTime =  parseInt(SessionStorage.get("lastPlayedTime"));
                    return lastPlayedTime;
                  },function (memoryVideo,currentTime) {
                    //console.log(memoryVideo,currentTime)
                  }
                ]
              }
            ],
            skinLayout: [
              {
                "name": "bigPlayButton",
                "align": "blabs",
                "x": 30,
                "y": 80
              },
              {
                "name": "H5Loading",
                "align": "cc"
              },
              {
                "name": "errorDisplay",
                "align": "tlabs",
                "x": 0,
                "y": 0
              },
              {
                "name": "infoDisplay"
              },
              {
                "name": "tooltip",
                "align": "blabs",
                "x": 0,
                "y": 56
              },
              {
                "name": "thumbnail"
              },
              {
                "name": "controlBar",
                "align": "blabs",
                "x": 0,
                "y": 0,
                "children": [
                  // 大按钮
                  {
                    "name": "playButton",
                    "align": "tl",
                    "x": 15,
                    "y": 12
                  },
                  // 进度条
                  {
                    "name": "progress",
                    "align": "blabs",
                    "x": 0,
                    "y": 44
                  },
                  {
                    "name": "timeDisplay",
                    "align": "tl",
                    "x": 10,
                    "y": 7
                  },
                  // 全屏
                  {
                    "name": "fullScreenButton",
                    "align": "tr",
                    "x": 10,
                    "y": 12
                  },
                  {
                    "name": "subtitle",
                    "align": "tr",
                    "x": 15,
                    "y": 12
                  },
                  {
                    "name": "setting",
                    "align": "tr",
                    "x": 15,
                    "y": 12
                  },
                  {
                    "name": "volume",
                    "align": "tr",
                    "x": 5,
                    "y": 10
                  },
                  // 截图
                  {
                    "name": "snapshot",
                    "align": "tr",
                    "x": 10,
                    "y": 12
                  }
                ]
              }
            ]
        }, function (player) {
            //console.log("The player is created");
        }
    );
};
